/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Online_Price_Col_UpdatedInputs */

const vi_online_price_col_updated = /** @type {(inputs: Online_Price_Col_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cập nhật`)
};

/**

* @param {Online_Price_Col_UpdatedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const online_price_col_updated = /** @type {((inputs?: Online_Price_Col_UpdatedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Online_Price_Col_UpdatedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_online_price_col_updated(inputs)
});